import { formatDate } from '@fiverr-private/futile';
import {
    dateTimeFormat,
    DATETIME_ELEMENT_STYLES
} from '@fiverr-private/localization';

/**
 * Format date - "Jun 10"
 * @param {string} isoDate ISO Date string.
 * @returns {string} Formatted date.
 */
export const dateFormatter = (isoDate) => {
    const date  = new Date(isoDate);
    const fallbackValue = formatDate(date, { year: false });

    return dateTimeFormat(date, {
        fallbackValue,
        month: DATETIME_ELEMENT_STYLES.SHORT,
        day: DATETIME_ELEMENT_STYLES.TWO_DIGIT
    });
};
